"use client";

import * as React from "react";
import { TabContext } from "@/core/commands";
import { can, useSession } from "@/core/session";
import { SCREEN_META, screenTitle, type Params, type ScreenKey } from "@/core/screen-meta";
import { EXTERNAL_PREFIX, type Tab } from "@/core/tabs";
import { ErrorState } from "@/components/misc";
import { SCREENS } from "@/shell/screens";
import { Page } from "../ui";

/**
 * Hospeda uma tela do desktop dentro do app mobile (formulários de cadastro,
 * sistema, nova viagem, exportações…). O layout dessas telas é responsivo.
 */
export function MDesk({ screen, params, routeKey, ativo }: { screen: ScreenKey; params: Params; routeKey: string; ativo: boolean }) {
  const papel = useSession((s) => s.usuario?.papel);
  const Screen = SCREENS[screen];
  const acao = SCREEN_META[screen]?.acao;
  const tab = React.useMemo<Tab>(() => ({ id: `${EXTERNAL_PREFIX}${routeKey}`, screen, params, title: screenTitle(screen, params), nonce: 0 }), [routeKey, screen, params]);
  const ctx = React.useMemo(() => ({ tab, active: ativo }), [tab, ativo]);
  const negado = acao && !can(papel, acao);
  return (
    <Page back title={screenTitle(screen, params)} fill>
      <div className="m-embed flex min-h-0 flex-1 flex-col overflow-auto bg-app">
        <TabContext.Provider value={ctx}>{negado ? <ErrorState code="403" /> : Screen ? <Screen params={params} /> : <ErrorState code="404" />}</TabContext.Provider>
      </div>
    </Page>
  );
}
